import { createSelector } from 'reselect'
import { getMarkets } from '../../api'

export const MARKETS_FETCHED = 'MARKETS_FETCHED'

export const fetchMarkets = () => (dispatch, getState) => {
  if (getState().markets.coins.length) {
    return
  }

  return getMarkets(250).then(response => {
    const data = response.data || response
    dispatch({
      type: MARKETS_FETCHED,
      coins: normalizeCoins(data)
    })
  })
}

const initialState = {
  coins: []
}

export default function reducer(state = initialState, action) {

  switch (action.type) {
    case MARKETS_FETCHED: {
      return {
        coins: action.coins
      }
    }

    default:
      return state
  }
}

export const selectMarketsCoins = createSelector(
  state => state.markets.coins,
  (_, category) => category,
  (coins, category) => {
    if (category) {
      return []
    }

    return coins
  }
)

export const selectTopGainers = createSelector(
  state => state.markets.coins,
  coins => {
    return coins.slice().sort((a, b) => b.priceChange24h - a.priceChange24h)
  }
)

export const selectTopLosers = createSelector(
  state => state.markets.coins,
  coins => {
    return coins.slice().sort((a, b) => a.priceChange24h - b.priceChange24h)
  }
)

export const selectTopGainers5 = createSelector(
  selectTopGainers, coins => coins.slice(0, 5)
)

export const selectTopLosers5 = createSelector(
  selectTopLosers, coins => coins.slice(0, 5)
)

// Normalizer

export function normalizeCoins(markets) {
  return markets.map(item => ({
    id: item.uid || item.id,
    name: item.name,
    image: item.image,
    symbol: item.code || item.symbol,
    rank: item.market_cap_rank,
    price: parseFloat(item.price || item.current_price),
    priceChange24h: parseFloat(item.price_change_24h || item.price_change_percentage_24h || 0),
    priceChange7d: parseFloat(item.price_change_7d || item.price_change_percentage_7d_in_currency || 0),
    priceChange14d: parseFloat(item.price_change_14d || item.price_change_percentage_14d_in_currency || 0),
    priceChange30d: parseFloat(item.price_change_30d || item.price_change_percentage_30d_in_currency || 0),
    priceChange200d: parseFloat(item.price_change_200d || item.price_change_percentage_200d_in_currency || 0),
    priceChange1y: parseFloat(item.price_change_1y || item.price_change_percentage_1y_in_currency || 0),
    marketCap: parseFloat(item.market_cap),
    totalVolume: parseFloat(item.total_volume),
  }))
}
